import { Routes } from '@angular/router';

/**
 * `flogin` es SOLO el login central: una ruta y nada mas.
 *
 * ⚠️ **No hay `invitadoGuard` en `login`, y la ausencia es deliberada.** En un
 * frontend con pantallas propias ese guard saca del login a quien ya tiene
 * sesion. Aqui estar autenticado **sin acceso elegido** es precisamente el
 * estado en el que hay que SEGUIR en esta pantalla, porque es donde se pinta la
 * rejilla de accesos. Con el guard puesto, autenticarse expulsaria al usuario de
 * la unica pantalla capaz de mostrarle sus accesos.
 *
 * El dia que el login gane una pantalla propia con sesion viva —un perfil, las
 * sesiones activas— esa ruta si lleva `sesionGuard`, que sigue exportado en
 * `@auth`.
 */
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage),
  },
  {
    // Todo cae al login. No se pierde el `volverA`: el router conserva los query
    // params en una redireccion de ruta.
    path: '**',
    redirectTo: 'login',
  },
];
